'use client'

import classnames from 'classnames'
import React, { ForwardedRef, type JSX } from 'react'
import Icon, { IconName } from '../icon'
import Link from 'next/link'

interface CommonProps {
  primary?: boolean
  defaultBtn?: boolean
  block?: boolean
  icon?: IconName
  iconSize?: string
  leftIcon?: boolean
  className?: string
  text?: string | JSX.Element
  link?: boolean
  href?: string
  forwardRef?: ForwardedRef<HTMLButtonElement>
  nextLink?: boolean
  shallow?: boolean
}

type CaseProps =
  | ({
    link: true
    href: string
    externalLink?: boolean
  } & React.AnchorHTMLAttributes<HTMLAnchorElement>)
  | ({
    link?: false
    href?: never
    externalLink?: never
  } & React.ButtonHTMLAttributes<HTMLButtonElement>)
  | ({
    nextLink: true
    href: string
    externalLink?: never
    shallow?: boolean
  } & React.ButtonHTMLAttributes<HTMLButtonElement>)

export type ButtonProps = CommonProps & CaseProps

export const Button = ({
  primary = false,
  defaultBtn = false,
  block = false,
  icon,
  iconSize,
  leftIcon = false,
  className = '',
  text,
  link = false,
  externalLink = false,
  href = '',
  type,
  forwardRef,
  nextLink = false,
  ...props
}: ButtonProps) => {
  const ButtonTag = nextLink ? Link : link ? 'a' : 'button'
  const hasText = !!text

  return (
    <ButtonTag
      className={classnames(`${className}`, {
        'c-btn': !defaultBtn,
        'c-btn--primary': primary,
        'c-btn--block': block,
        [hasText ? 'c-btn--w-icon' : 'c-btn--icon']: icon,
        'c-btn--w-icon--left': leftIcon,
      })}
      {...(link ? { href } : {})}
      {...(link && externalLink ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      {...(forwardRef ? { ref: forwardRef } : {})}
      {...(!link ? { type: type ?? 'button' } : { type })}
      {...(props as any)}>
      {text}
      {icon && (
        <Icon
          className={`c-btn__icon ${iconSize ? iconSize : hasText ? 'i-20' : 'i-16'}`}
          name={icon}
        />
      )}
    </ButtonTag>
  )
}

export default Button
